import React, { useEffect } from 'react';
import { CustomFilterCard } from '../../../../shared/Cards/CustomCard';
import CustomTable from '../../../../shared/Table/CustomTable';
import { useDispatch, useSelector } from 'react-redux';
import { deleteReport, getReports } from '../../../../redux/actions/More/ReportAction';
import { confirmDelete } from '../../../../utils/commonFunctions';
import { useHistory } from 'react-router-dom';

export default function ReportsList() {
    const history = useHistory();
    const dispatch = useDispatch();
    const columns = [
        { field: 'title', header: 'Title' },
        { field: 'description', header: 'Description' },
    ];

    useEffect(() => {
        dispatch(getReports());
    }, [dispatch]);

    const allReports = useSelector((state) => state?.moreReport?.reports);

    const onEdit = (col) => {
        history.push(`/more/reports/edit/${col._id}`);
    };

    const onDelete = (col, position) => {
        confirmDelete(
            () => {
                dispatch(deleteReport(col._id, () => {}));
            },
            'Do you want to delete this report ?',
            position,
        );
    };
    return (
        <>
            <CustomFilterCard buttonTitle="Add Report" linkTo="/more/reports/add" />
            <CustomTable data={allReports} columns={columns} onEdit={onEdit} onDelete={onDelete} />
        </>
    );
}
